import React, { useEffect, useState } from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { t } from 'translation'

import RegisterDoctorBody from 'components/RegisterDoctor/RegisterDoctorBody'
import Spinner from 'components/ui/Spinner/Spinner'

import { inviteApi } from 'api'
import { setCurrentLanguage } from 'translation'
import { authFail, resetAuthError } from 'store/actions'

const RegisterDoctorPage = ({ authFail, resetAuthError, language }) => {
  const ENV = process.env.NODE_ENV
  const elearningUrl =
    ENV === 'production'
      ? process.env.ADMIN_URL_PRODUCTION
      : ENV === 'dev-remote'
      ? process.env.ADMIN_URL_DEV_REMOTE
      : process.env.ADMIN_URL_DEVELOPMENT

  const history = useHistory()
  const [parseParams, setParseParams] = useState(false)
  const [inviteDoctor, setInviteDoctor] = useState('')

  useEffect(() => {
    setCurrentLanguage(language, true)
    const checkInviteDoctorParam = async () => {
      const searchParams = new URLSearchParams(window.location.search)
      const inviteDoctorIdParam = [...searchParams].find(([key]) => key === 'id')?.[1]
      const conformsToIdShape = /^[a-z0-9]{24}$/.test(inviteDoctorIdParam)

      if (!conformsToIdShape) {
        setParseParams(true)
        authFail(t('registrationPage.INVALID_INVITE'))
        const signInLink = `/login`
        return setTimeout(() => (resetAuthError(), history.push(signInLink)), 4000)
      }

      const { result, error } = await inviteApi.getInvitationDoctorInfo(
        inviteDoctorIdParam
      )

      if (error) {
        console.log('Error:', error)

        const parsedError =
          error.status === 404 || error.status === 422
            ? t('registrationPage.INVALID_INVITE')
            : error

        setParseParams(true)
        authFail(parsedError)

        const signInLink = `/login`
        return setTimeout(() => (resetAuthError(), history.push(signInLink)), 5000)
      }

      const { inviteDoctor, needsELearning } = result
      const { eLearningAccessAt } = inviteDoctor
      if (needsELearning && !eLearningAccessAt) {
        setParseParams(true)
        authFail('PLEASE_COMPLETE_E_LEARNING_MODULE')

        const elearningLink =
          language === 'fr'
            ? `${elearningUrl}/bienvenue?id=${inviteDoctor.id}`
            : `${elearningUrl}/welcome?id=${inviteDoctor.id}`

        return setTimeout(
          () => (resetAuthError(), window.location.replace(elearningLink)),
          5000
        )
      }

      if (needsELearning)
        await inviteApi.setCompletedTrainingDateOnInvitationPro(inviteDoctorIdParam)

      setInviteDoctor(inviteDoctor)

      setParseParams(true)
    }
    checkInviteDoctorParam()
  }, [])

  return (
    <>
      <Helmet title={t('registrationPage.DOCTOR_REGISTRATION')} />
      {parseParams ? (
        <RegisterDoctorBody inviteDoctor={inviteDoctor} defaultLanguage={language} />
      ) : (
        <Spinner className="spinner_button" />
      )}
    </>
  )
}

const mapStateToProps = ({ auth: { error } }) => ({ authError: error })
const willMapDispatchToProps = { authFail, resetAuthError }

export default connect(mapStateToProps, willMapDispatchToProps)(RegisterDoctorPage)
